import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonTable } from './../../model/entity/commonTable';
import { FormBuilder, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { CommonTableService } from 'app/service/common-table.service';
import { UrlDetails } from 'app/model/entity/api-details';
import { DialogService } from 'app/service/dialog.service';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { Constant } from 'app/config/constants';

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && typeof control.value === 'string') {
    const isWhitespace = control.value.trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }
  return null;
}

// allow url start with https, contain only half-witdh number, character and symbol that can appear in an url
const URL_REGEX = /^https:\/\/[A-Za-z0-9\-._~:/?#\[\]@!$&'()*+,;=%]+$/;

@Component({
  selector: 'dialog-api-definition-setting',
  templateUrl: './dialog-api-definition-setting.component.html',
  styleUrls: ['./dialog-api-definition-setting.component.scss']
})
export class DialogApiDefinitionSettingComponent implements OnInit {
  apiDefinitionSettingForm: FormGroup;

  /**
   * msg url
   */
  public msgURL: String;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DialogApiDefinitionSettingComponent>,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    public translateService: TranslateService,
    private commonTableService: CommonTableService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.apiDefinitionSettingForm = this.formBuilder.group({
      url: [null]
    });
    const apiDetails: UrlDetails = JSON.parse(this.data.commonTable.value);
    this.apiDefinitionSettingForm.get('url').setValue(apiDetails.url);
  }

  private validateUrl() {
    let isValid = true;
    const url = this.apiDefinitionSettingForm.get('url').value;
    if (url == '') {
      this.msgURL = this.translateService.instant('dialog-api-details.msg.url-empty');
      isValid = false;
    } else if (!URL_REGEX.test(url)) {
      this.msgURL = this.translateService.instant('dialog-api-details.msg.url-wrong-format');
      isValid = false;
    } else {
      this.msgURL = '';
    }
    return isValid;
  }

  private showUpdateFail(e?: any): void {
    const errMsg =
      e && e.status === Constant.NETWORK_ERROR_CODE
        ? this.translateService.instant('dialog-error.error-network-api')
        : this.translateService.instant('dialog-api-definition-setting.error');
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-error.title'),
        texts: [errMsg]
      }
    });
  }

  /**
   * save
   */
  public save(): void {
    if (!this.validateUrl()) {
      return;
    }
    let apiDetail = new UrlDetails(this.apiDefinitionSettingForm.get('url').value);
    this.data.commonTable.value = JSON.stringify(apiDetail);
    this.commonTableService.save(this.data.commonTable).subscribe(
      result => {
        this.toast.success(this.translateService.instant('common.save-success'), '');
        this.dialogRef.close(result);
      },
      e => {
        this.showUpdateFail(e);
      }
    );
  }

  /**
   * close dialog
   */
  public closeDialog(): void {
    this.dialogRef.close(undefined);
  }

  isFieldInvalid(fieldName: string): boolean {
    const control = this.apiDefinitionSettingForm.get(fieldName);
    return !!(control && control.invalid && (control.touched || control.dirty));
  }

  hasError(fieldName: string, errorType: string): boolean {
    const control = this.apiDefinitionSettingForm.get(fieldName);
    return !!(control && control.errors && control.errors[errorType]);
  }
}

/**
 * interface DialogData
 */
export interface DialogData {
  commonTable: CommonTable;
}
